<template>
  <div :style="themeStyle">
    <div
      v-if="show"
      class="search-view animate__animated animate__fadeIn"
    >
      <div class="search-container container animate__animated animate__slideInUp">
        <div class="header">
          <h2 class="search-title">
            站內搜尋
          </h2>
          <div
            class="back"
            @click="openSearch"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line
                x1="18"
                y1="6"
                x2="6"
                y2="18"
              />
              <line
                x1="6"
                y1="6"
                x2="18"
                y2="18"
              />
            </svg>
            返回
          </div>
        </div>
        <div class="input-area">
          <div class="input-wrapper">
            <label class="search-icon">
              <span class="fi-rr-search" />
            </label>
            <input
              ref="searchInput"
              v-model="searchQuery"
              class="search-input"
              @keyup="searchPress"
            >
            <button
              v-if="searchQuery"
              name="clearSearch"
              class="clear-btn"
              @click="searchQuery = ''"
            >
              <span class="fi-rr-cross" />
            </button>

            <div
              v-if="footerDisplay"
              class="d-none d-lg-flex flex-column flex-shrink-0"
            >
              <span class="search-by">
                SEARCH BY
              </span>
              <a href="https://web-hosts.net/">
                <b-img
                  :src="require('@/assets/images/logo/gamehost-text.png')"
                  alt="Search by GameHost"
                  width="150"
                  fluid
                />
              </a>
            </div>
          </div>
          <div
            ref="search-history"
            class="search-history animate__animated animate__fadeIn"
          >
            <ul
              v-if="searchHistory.length > 0"
              class="history-list"
            >
              <li
                v-for="record, index in searchHistory"
                :key="index"
                class="history-item"
                @click="searchQuery = record"
              >
                <div>
                  {{ record }}
                </div>
                <div
                  class="history-icon"
                  @click.stop="removeHistory(record, index)"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    size="20"
                  />
                </div>
              </li>
            </ul>
            <div
              v-else
              class="no-history"
            >
              查無紀錄
            </div>
          </div>
        </div>
        <div
          class="data-area"
        >
          <div
            v-if="!isBusy"
            class="data-list"
          >
            <div
              v-for="category, index in searchData"
              :key="index"
              class="data-item"
            >
              <div
                v-if="category.forums.length > 0"
                class="d-flex justify-content-between align-items-center"
              >
                <router-link
                  :to="{name: 'class', params: {category_name: category.name, category_id: category.id}}"
                >
                  <h3 class="category-name">
                    {{ category.name }}
                  </h3>
                </router-link>
                <div class="mr-50 d-flex flex-column flex-sm-row align-items-center">
                  <div v-if="(category.forums.length > 4 && window.width > 991) || (category.forums.length > 2 && window.width < 992)">
                    <button
                      class="slick-btn"
                      @click="onSlick(index, false)"
                    >
                      <span class="fi-rr-angle-square-left" />
                    </button>
                    <button
                      class="slick-btn"
                      @click="onSlick(index, true)"
                    >
                      <span class="fi-rr-angle-square-right" />
                    </button>
                  </div>
                  <span>
                    共{{ category.forums.length }}筆資料
                  </span>
                </div>
              </div>
              <slick
                ref="slick"
                :options="simpleSlickOptions(category)"
                class="card-slick"
              >
                <div
                  v-for="article in category.forums"
                  :key="article.id"
                >
                  <div
                    class="article-card card"
                    :class="{single: category.forums.length === 1}"
                  >
                    <router-link
                      :to="{
                        name: 'article',
                        params: {
                          article_name: article.title,
                          article_id: article.id,
                        }
                      }"
                      class="article-link"
                    >
                      <div>
                        <div class="article-title">
                          <h3 class="article-name">
                            {{ article.title }}
                          </h3>
                          <p
                            class="views"
                          >
                            <span class="article-icon fi-rr-eye" />
                            {{ article.page_views }}
                          </p>

                        </div>
                        <p
                          v-if="article.description"
                          class="description"
                        >
                          {{ article.description }}
                        </p>
                        <p
                          v-else
                          class="description"
                        >
                          尚無描述
                        </p>
                      </div>
                      <div class="article-info">
                        <div
                          v-b-tooltip.bottom.hover.focus.v-secondary
                          :title="`${dayjs(article.last_updated_at).format('YYYY-MM-DD HH:mm:ss')}`"
                          variant="gradient-primary"
                          class="updated-time"
                        >
                          <span>
                            {{ updateOnline(article.last_updated_at) }}
                          </span>
                        </div>
                        <p
                          v-if="article.author"
                          class="author"
                        >
                          {{ article.author }}
                        </p>
                        <p
                          v-else
                          class="author"
                        >
                          匿名
                        </p>
                      </div>
                    </router-link>
                  </div>
                </div>
              </slick>
            </div>
          </div>
        </div>
        <br>
      </div>
    </div>
    <div
      v-if="!show"
      ref="searchBtn"
      class="go-search animate__animated animate__lightSpeedInRight"
    >
      <button
        class="search-btn"
        name="search-btn"
        title="文章搜尋"
        @click="openSearch"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M23.111 20.058l-4.977-4.977c.965-1.52 1.523-3.322 1.523-5.251 0-5.42-4.409-9.83-9.829-9.83-5.42 0-9.828 4.41-9.828 9.83s4.408 9.83 9.829 9.83c1.834 0 3.552-.505 5.022-1.383l5.021 5.021c2.144 2.141 5.384-1.096 3.239-3.24zm-20.064-10.228c0-3.739 3.043-6.782 6.782-6.782s6.782 3.042 6.782 6.782-3.043 6.782-6.782 6.782-6.782-3.043-6.782-6.782zm2.01-1.764c1.984-4.599 8.664-4.066 9.922.749-2.534-2.974-6.993-3.294-9.922-.749z" />
        </svg>
      </button>
      <div class="search-border" />
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api' // watch

import {
  BImg, VBTooltip,
} from 'bootstrap-vue'

import Slick from 'vue-slick'

import dayjs from 'dayjs'
import axios from 'axios'

import 'animate.css'
import 'slick-carousel/slick/slick.css'
// import router from '@/router'

export default {
  components: {
    BImg,
    Slick,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    themeStyle: {
      type: Object,
      required: true,
    },
    footerDisplay: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      slickOptions: {
        rows: 2,
        autoplay: false,
        arrows: false,
        mobileFirst: true,
        draggable: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
        // vertical: true,
        // variableWidth: true,
      },
      lastInput: '',
      show: false,
    }
  },
  computed: {
  },
  watch: {
    $route: 'resetComponent',
    searchQuery(value) {
      const histories = localStorage.getItem('search') ? JSON.parse(localStorage.getItem('search')) : []
      if (value) this.searchHistory = histories.filter(history => history.includes(this.searchQuery))
      else {
        this.searchHistory = histories
        this.getSearchData()
      }
    },
  },
  created() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
    document.removeEventListener('click', this.controlHistory)
  },
  mounted() {
  },
  methods: {
    dayjs,
    // 時間格式
    updateOnline(time) {
      const createTime = Math.floor(new Date(time).getTime() / 1000)
      const createHour = String(new Date(time).getHours())
      const createMinute = String(new Date(time).getMinutes())
      const today = Math.floor(new Date().getTime() / 1000)
      const diffTime = today - createTime
      if (diffTime < 0) return '時間錯誤'
      // 定義單位時間
      const second = 1
      const minute = second * 60
      const hour = minute * 60
      const day = hour * 24
      // 定義換算時間
      let calcTime
      const secondCalc = parseInt(diffTime / second, 10)
      const minuteCalc = parseInt(diffTime / minute, 10)
      const hourCalc = parseInt(diffTime / hour, 10)
      const dayCalc = parseInt(diffTime / day, 10)
      if (dayCalc >= 1 && dayCalc <= 7) {
        if (dayCalc === 1) {
          calcTime = `昨天 ${createHour.padStart(2, '0')}:${createMinute.padStart(2, '0')}`
        } else if (dayCalc === 2) {
          calcTime = `前天 ${createHour.padStart(2, '0')}:${createMinute.padStart(2, '0')}`
        } else {
          calcTime = `${dayCalc} 天前`
        }
      } else if (hourCalc >= 1 && hourCalc <= 23) {
        calcTime = `${hourCalc} 小時前`
      } else if (minuteCalc >= 1 && minuteCalc <= 59) {
        calcTime = `${minuteCalc} 分鐘前`
      } else if (secondCalc >= 1 && secondCalc <= 59) {
        calcTime = `${secondCalc} 秒前`
      } else {
        calcTime = dayjs(time).format('YYYY-MM-DD HH:mm')
      }
      return calcTime
    },
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      // const webpSrc = `${src.split('.')[0]}.webp`
      return webpSrc
    },
    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    resetComponent() {
      if (this.show) this.openSearch()
      if (this.$route.name === 'article') {
        const id = this.$route.params.article_id
        this.$emit('resetData', id)
      } else if (this.$route.name === 'class') {
        const id = this.$route.params.category_id
        this.$emit('resetData', id)
      }
    },
    simpleSlickOptions(data) {
      const len = data.forums.length
      const options = JSON.parse(JSON.stringify(this.slickOptions))
      options.rows = Math.ceil(len / 2) >= 2 ? 2 : 1
      return options
    },
    openSearch() {
      if (!this.show) {
        this.show = !this.show
        setTimeout(() => {
          document.addEventListener('click', this.controlHistory)
        }, 1500)
      } else {
        document.removeEventListener('click', this.controlHistory)
        this.show = !this.show
        this.searchQuery = ''
      }
    },
    controlHistory(event) {
      if (!this.$refs['search-history']) return
      if (event.target !== this.$refs.searchInput && event.target !== this.$refs['search-history']) {
        this.$refs['search-history'].classList.remove('show')
      } else {
        this.$refs['search-history'].classList.add('show')
      }
    },
    removeHistory(item, index) {
      const histories = localStorage.getItem('search') ? JSON.parse(localStorage.getItem('search')) : []
      const itemIndex = histories.indexOf(item)
      histories.splice(itemIndex, 1)
      localStorage.setItem('search', JSON.stringify(histories))
      this.searchHistory.splice(index, 1)
    },
    searchPress(event) {
      if (!this.searchQuery) return
      const histories = localStorage.getItem('search') ? JSON.parse(localStorage.getItem('search')) : []
      const repeat = histories.some(history => history === this.searchQuery)
      if (event.key === 'Enter') {
        if (!repeat) histories.unshift(this.searchQuery)
        localStorage.setItem('search', JSON.stringify(histories))
        this.searchHistory = histories.filter(history => history.includes(this.searchQuery))
        if (this.lastInput !== this.searchQuery) this.getSearchData()
        this.lastInput = this.searchQuery
        this.$refs['search-history'].classList.add('show')
      }
    },
    onSlick(index, next) {
      if (next) this.$refs.slick[index].next()
      else this.$refs.slick[index].prev()
    },
  },
  setup() {
    const isBusy = ref(false)

    const searchQuery = ref('')
    const searchHistory = ref([])
    const searchData = ref(null)

    const getSearchData = () => {
      isBusy.value = true
      searchData.value = null
      searchHistory.value = localStorage.getItem('search') ? JSON.parse(localStorage.getItem('search')) : []
      if (searchQuery.value) {
        searchHistory.value = searchHistory.value.filter(history => history.includes(searchQuery.value))
      }
      axios
        .get('https://forum.web-hosts.net/api/web/forum/search', {
          params: { search: searchQuery.value },
        })
        .then(response => {
          searchData.value = response.data.data.data
          isBusy.value = false
        })
        .catch(() => {
          isBusy.value = false
        })
    }
    // #EE1B2E #33CCFF #EE5023 #3C9D40 #8F2A90

    getSearchData()
    return {
      searchHistory,
      searchQuery,
      searchData,
      isBusy,
      getSearchData,
    }
  },
}
</script>
<style lang="scss" scoped>
$text-color: var(--text-color);
.search-view {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 100vw;
  // max-height: 200vh;
  padding: 60px;
  background: #1d1d1dd2;
  backdrop-filter: blur(5px);
  color: #fff;
  @media screen and (max-width: 767px) {
    height: 150vh;
    padding: 50px;
  }
  @media screen and (max-width: 575px) {
    padding: 50px 20px;
  }
}
.search-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.header {
  width: 100%;
  min-height: 50px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .search-title {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    line-height: 1.5;
    color: #fff;
  }
  .back {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
.input-area {
  position: relative;
  width: 100%;
  min-height: 100px;
  .input-wrapper {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    background-color: #e6e6e7;
    padding: 10px 15px 10px 30px;
    border-radius: 10px;
    height: 80px;
    .search-icon {
      margin: 5px 0 0;
      span {
        font-size: 20px;
      }
    }
    .search-input {
      width: 100%;
      line-height: 1.5;
      font-size: 18px;
      background-color: transparent;
      border: none;
      padding-left: 20px;
      &:focus{
        outline:none;
      }
    }
    .clear-btn {
      padding: 10px;
      border: none;
      background-color: transparent;
      margin: 5px 6px 0;
      // margin-right: 12px;
      span {
        font-size: 18px;
      }
    }
    .search-by {
      padding-left: 4px;
      font-size: 15px;
      font-weight: 900;
      letter-spacing: .5px;
      color: #1d1d1d;
    }
    @media screen and (max-width: 767px) {
      padding: 10px 15px 10px 20px;
    }
  }
  .search-history {
    position: absolute;
    z-index: 10;
    top: calc(100% - 10px);
    display: none;
    padding: 10px;
    width: 100%;
    border-radius: 5px;
    max-height: 140px;
    background-color: #fff;
    overflow: hidden;
    .history-list{
      padding: 0;
      margin: 0;
      .history-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: rgb(38, 38, 39);
        font-size: 16px;
        padding: 6px 10px;
        margin: 6px 0;
        border-radius: 3px;
        cursor: pointer;
        &:hover {
          background-color: rgba(179,173,214,0.204);
        }
      }
      .history-icon {
        color: #a3a3a3;
        &:hover {
          color: #1d1d1d;
        }
      }
    }
    .no-history {
      color: rgb(38, 38, 39);
      font-size: 16px;
      padding: 6px 10px;
    }
    &.show {
      display: block;
    }
  }
  @media screen and (max-width: 991px) {
    min-height: 80px;
    .input-wrapper {
      height: 60px;
    }
  }
  @media screen and (max-width: 767px) {
    min-height: 80px;
    .input-wrapper {
      height: 50px;
    }
    .search-history {
      top: calc(100% - 20px);
    }
  }
}
.data-area {
  width: 100%;
  height: calc(100vh - 300px);
  overflow: scroll;
  .data-list {
    // display: flex;
    // flex-direction: column;
    width: 100%;
  }
  .category-name {
    margin: 30px 0;
    font-weight: 400;
    color: #fff;
  }
  .slick-btn {
    border: none;
    background-color: transparent;
    // padding: 1px 2px;
    span {
      font-size: 20px;
      margin-top: 4px;
      color: #fff;
    }
  }
  .card-slick {
    width: 100%;
    .article-card {
      height: 180px;
      width: 96%;
      margin: 2%;
      // &.single {
      //   width: 48%;
      // }
    }
  }
  .article-card {
    .article-link {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 20px;
    }
    .article-icon {
      margin-top: 5px;
      margin-right: 3px;
    }
    .article-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .article-name {
      font-weight: 800;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .article-info {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
    }
    .description {
      color: #000;
      // height: 100%;
      margin: 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
    .views, .author, .updated-time {
      display: flex;
      align-items: center;
      color: #6d6d6d;
      text-align: right;
      margin: 0;
    }
  }
}
.go-search {
  position: fixed;
  z-index: 1000;
  top: 2%;
  right: 2%;
  width: 50px;
  height: 50px;
  cursor: pointer;
  .search-border {
    position: absolute;
    top: 0;
    left: 0;
    width: 50px;
    height: 50px;
    opacity: 0;
    border-radius: 50%;
    border: 2px solid $text-color;
    transition: all 1.5s, opacity .4s;
    // &.active {
    //   transform: scale(calc(200vmax / 50));
    //   box-shadow: inset 0 0 20px rgba(255, 255, 255, .5), 0 0 20px rgba(255, 255, 255, .2);
    // }
  }
  .search-btn {
    position: relative;
    z-index: 1;
    width: 50px;
    height: 50px;
    border: none;
    padding: 0;
    background: transparent;
    text-shadow: none;
    svg {
      fill:$text-color;
      width: 25px;
      height: 25px;
    }
    @media screen and (max-width: 767px) {
      padding: 5px;
      max-width: 50px;
      max-height: 50px;
    }
  }
  &:hover {
    .search-border {
      opacity: 1;
    }
  }
}
</style>
<style>
.slick-track {
  margin: 0 ;
}
</style>
